<template>
  <div>
    <div>
      <div class="accordion-header collapsed">
        <button
          class="accordion-button"
          :class="{ collapsed: !isOpen }"
          :aria-expanded="isOpen"
          @click="toggleForm"
        >
          {{ familyData.details.forename }} {{ familyData.details.surname }}
        </button>
      </div>
      <div
        class="accordion-collapse collapse"
        :class="{ show: isOpen }"
        aria-labelledby="panelsStayOpen-headingOne"
      >
        <div class="accordion-body">
          <div :id="'additional-members-' + memberIndex">
            <div class="form-group border-start p-3 my-3 border-primary">
              <div class="mb-4">
                <PolicyHolderByFamily
                  :family-data="familyData"
                  :member-index="memberIndex"
                  class="form-section"
                />
                <PhysicianDetailsByFamily
                  :family-data="familyData"
                  :member-index="memberIndex"
                  class="form-section"
                />
                <DocumentUpload
                  :member-index="memberIndex"
                  :documents="familyData.additionalDetails.documents"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import PolicyHolderByFamily from './PolicyHolderByFamily.vue'
import PhysicianDetailsByFamily from './PhysicianDetailsByFamily.vue'
import DocumentUpload from '../DocumentUpload.vue'

export default {
  name: 'PolicyHolderDetails',
  components: {
    PolicyHolderByFamily,
    PhysicianDetailsByFamily,
    DocumentUpload,
  },
  props: {
    familyData: { type: Object, required: true },
    memberIndex: { type: Number, required: true },
    // documents: { type: Array, default: () => [] },
    isCollapse: {
      type: Boolean,
      require: true,
    },
  },
  data() {
    return {
      isOpen: this.isCollapse,
    }
  },
  watch: {
    isCollapse() {
      this.isOpen = this.$isCollapse
    },
  },
  mounted() {},
  methods: {
    toggleForm() {
      this.isOpen = !this.isOpen
    },
  },
}
</script>
<style>
.accordion-body {
	padding: unset
}
</style>
